<template>

  <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5" @invalid-submit="onInvalidSubmit">

    <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

      <h1 class="font-bold text-center text-2xl">Acreditación de Público General</h1>
      <h1 class="font-bold text-center text-xl">Por favor complete el formulario</h1>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Tipo de documento (*)</label>
          <Field name="tipoDocumento" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoDocumento">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Tipo de documento" class="input-base" :options="tiposDocumentos" optionLabel="descripcion" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoDocumento" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Número (*)</label>
          <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
            <InputText v-bind="field" type="text" @blur="validarDni" class="input-base" placeholder="Número de documento" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Nombre (*)</label>
          <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Apellido (*)</label>
          <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Mail (*)</label>
          <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
            <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Empresa / Institución (*)</label>
          <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa / Institución" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
          </Field>
        </div>
      </div>
      
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Cargo (*)</label>
          <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Cargo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Provincia (*)</label>
          <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="provincia" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
        <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">País</label>
            <Select v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="input-base"/>
        </div>
        <div class="w-full px-2 md:w-2/12">
          <label class="block mb-1">Prefijo</label>
          <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Código de área</label>
          <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Código de área" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-4/12">
          <label class="block mb-1">Teléfono</label>
          <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Teléfono" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
          </Field>
        </div>
      </div>
      
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">        
        <div class="w-full px-2 md:w-12/12">
          <label class="block mb-1">Tiene alguna restricción alimentaria? (*)</label>
          <Field name="restriccionAlimentaria" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.restriccionAlimentaria">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione una opción" :options="restricciones" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="restriccionAlimentaria" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
        <div class="w-full px-2 flex flex-row gap-2">
          <ToggleSwitch v-model="formData.aceptaTeriminos" inputId="idAceptaTerminos" />
          <label for="idAceptaTerminos" class="cursor-pointer">Acepto los términos y condiciones del evento (*)</label>
        </div>
      </div>

      <!--div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
        <div class="w-full px-2 flex flex-row gap-2">
          <ToggleSwitch v-model="formData.autorizacionUsoImagen" inputId="idAutorizacionUsoImagen" />
          <label for="idAutorizacionUsoImagen" class="cursor-pointer">Autorizo el uso de mi imagen (*)</label>
        </div>
      </div-->

      <div class="flex flex-wrap py-2 mt-3 jusi">
        <button type="submit" label="REGISTRARME"
          class="mt-8 bg-[#175c8c] hover:bg-[#0f3449] hover:to-black text-white px-4 py-2 rounded-md transition-all duration-200"
          :disabled="isSubmitting">
          <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
          <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> REGISTRARME
        </button>
      </div>
    </div>

    
  </Form>


  <FullScreenLoader :visible="isSubmitting" />

</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import ToggleSwitch from 'primevue/toggleswitch';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity, TipoAcreditado } from 'qreventos-suite/services';

import {  SAVE, ORIGEN_ACREDITADO, A_VERIFICAR } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import jsonTiposDocumentos from '@/data/tiposDocumentos.json';
import jsonRestricciones from '@/data/restricciones.json';
import jsonProvincias from '@/data/provincias.json';

interface TipoDocumento extends StringIdLabelEntity {}
interface Provincia extends IdLabelEntity {}
interface RestriccionAlimentaria extends StringIdLabelEntity {}

interface Pais {
  code: string;
  value: string;
}

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select, ToggleSwitch, 
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      provincias: jsonProvincias as Provincia[],
      tiposDocumentos: jsonTiposDocumentos as TipoDocumento[],
      restricciones: jsonRestricciones as RestriccionAlimentaria[],
      formData: {  
        tipoDocumento: undefined as unknown as TipoDocumento,
        dni: '',
        nombre: '',
        apellido: '',
        mail: '',
        empresa: '',
        codigoArea: '',
        numeroTelefono: '',
        provincia: undefined as unknown as Provincia,
        aceptaTeriminos: false,
        cargo: '',
        //autorizacionUsoImagen: false,
        restriccionAlimentaria: undefined as unknown as RestriccionAlimentaria
      }
    };
  }, 
  created () {
    document.title = "Cumbre federal de logísitca 2026";
  },
  computed: {
    schema() {
      return yup.object({
        tipoDocumento: yup.object().required("Seleccione una opción"),
        dni: yup.string().required("Ingrese el documento").min(6, "Al menos 6 caracteres"),
        nombre: yup.string().required("Ingrese el nombre").min(3, "Al menos 3 caracteres"),        
        apellido: yup.string().required("Ingrese el apellido").min(3, "Al menos 3 caracteres"),
        mail: yup.string().required("Ingrese el mail").email("Mail inválido"),
        empresa: yup.string().required("Ingrese la empresa").min(3, "Al menos 3 caracteres"),
        provincia: yup.object().required("Seleccione una opción"),
        restriccionAlimentaria: yup.mixed().required("Seleccione una opción"),
        cargo: yup.string().required("Ingrese el cargo").min(3, "Al menos 3 caracteres"),
      });
        
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + " error/es)", icon: "error"});
    },
    async validarDni() {
      try {
        if (this.formData.dni) {
          this.isSubmitting = true;
          let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.dni) as Acreditado;
          if (acreditadoExistente) {
            this.isSubmitting = false;
            Swal.fire({ title: "¡Atención!", html: "Ya estas registrado con este documento", icon: "warning" });
            return;
          }
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async onSubmit() {

        if(!this.formData.aceptaTeriminos) {
          Swal.fire({ title: "Error", text: "Debe aceptar los términos y condiciones", icon: "error" });
          return;
        }
/*        if(!this.formData.autorizacionUsoImagen) {
          Swal.fire({ title: "Error", text: "Debe aceptar la autorización para el uso de imagen", icon: "error" });
          return;
        }*/

      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
            this.isSubmitting = false;
              Swal.fire({ title: "El DNI ingresado ya fue registrado",  html: "Ya estás inscripto. Te enviaremos el código QR de acceso a tu correo antes del evento", icon: "warning" }).then(() => {
                  this.isSubmitting = false;
              });
              return;
        }

        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = { "id" : 2641 } as TipoAcreditado,
        acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.dato5 = this.formData.tipoDocumento?.id;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.mail = this.formData.mail;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.dato7 = this.formData.provincia?.descripcion;
        acreditado.empresa = this.formData.empresa;
        acreditado.cargo = this.formData.cargo;
        acreditado.dato6 = this.formData.restriccionAlimentaria?.id;

        //if(this.formData.autorizacionUsoImagen) {
          acreditado.dato4 = "SI";
        //} else {
        //  acreditado.dato4 = "NO";
        //}

        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Gracias por inscribirte!",  html: "Ya estás inscripto. Te enviaremos el código QR de acceso a tu correo antes del evento", icon: "info" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  }
});
</script>